export default function findPathByValue(obj, targetValue, currentPath = []) {

  if (!targetValue.length) return ""

  for (const key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) continue

    const value = obj[key]
    const path = [...currentPath, key]

    // Direct match
    if (value === targetValue) {
      return `{{${path.join(".")}}}`
    }

    // If nested object, search deeper
    if (typeof value === "object" && value !== null) {
      const nestedPath = findPathByValue(value, targetValue, path)
      if (nestedPath) return nestedPath
    }
  }
  return "" // not found
}